// extracted by mini-css-extract-plugin
export var active = "_h1-1";
export var circle = "_h1-0";
export var completed = "_h1-2";
export var connector = "_h1-4";
export var connectorCompleted = "_h1-7";
export var connectorSpacer = "_h1-5";
export var iconStrokeOverride = "_h1-8";
export var labelContainer = "_h1-6";
export var pending = "_h1-3";